import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { featuredVideos, categories } from '@/mocks/videos';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = featuredVideos;

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    const timer = setInterval(nextSlide, 6000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  const currentVideo = slides[currentSlide];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {slides.map((video, index) => (
        <div
          key={video.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={video.heroUrl}
            alt={video.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>
        </div>
      ))}

      <button
        onClick={prevSlide}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white transition-colors cursor-pointer z-10"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white transition-colors cursor-pointer z-10"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === currentSlide
                ? 'w-6 bg-primary-500'
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`切换到第${index + 1}张`}
          ></button>
        ))}
      </div>

      <div className="absolute bottom-16 md:bottom-24 left-0 right-0 z-10">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-[1200px] mx-auto">
            <div className="flex flex-col md:flex-row md:items-end gap-4 md:gap-8">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-white">
                    {categories.find(c => c.id === currentVideo.category)?.name}
                  </span>
                  <span className="text-white/70 text-sm">{currentVideo.year}</span>
                  <span className="text-accent-400 text-sm font-semibold">★ {currentVideo.rating}</span>
                </div>
                <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-2">
                  {currentVideo.title}
                </h2>
                <p className="text-white/80 text-sm max-w-lg line-clamp-2 hidden md:block">
                  {currentVideo.description}
                </p>
                <div className="flex items-center gap-2 mt-2 text-white/60 text-xs hidden md:flex">
                  <span>主演：{currentVideo.actors.slice(0, 3).join(' / ')}</span>
                </div>
              </div>
              <Link
                to={`/detail/${currentVideo.id}`}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-medium transition-colors whitespace-nowrap cursor-pointer self-start md:self-auto"
              >
                <i className="ri-play-fill text-lg"></i>
                <span>立即观看</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-background-50 to-transparent z-10"></div>
    </section>
  );
}